import { useUnit } from "effector-react";

import { $currentLocale, setCurrentLocale } from "../model";

export const useLocale = <L extends string>() => {
  const [locale, setI18Locale] = useUnit([$currentLocale, setCurrentLocale]);
  return { locale: locale as L, setI18Locale: setI18Locale as (l: L) => void };
};
